// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__11x7O","upload":"Small_upload__1LdgF","imageWrap":"Small_imageWrap__Jq6aF","removeBtn":"Small_removeBtn__HMxoZ"};